export default __webpack_public_path__ + "static/media/bg_2.f00471f2.jpg";